import { AutogenModelEdiCopyToCompany, AutogenRowEdiCopyToCompany } from "./autogen/AutogenModelEdiCopyToCompany";

export class ModelEdiCopyToCompany extends AutogenModelEdiCopyToCompany<RowEdiCopyToCompany> {
	constructor() {
		super(RowEdiCopyToCompany);
	}
}

export class RowEdiCopyToCompany extends AutogenRowEdiCopyToCompany {
}